export default "__VITE_ASSET__BQjLfT6K__"